/**
 * RadioSlider 1.0.0-beta.1
 * A jQuery plugin to display radio buttons as a slider..
 * (c) 2019 tcharlss / Ruben Torres
 * MIT license
 */
 (function($) {
  'use strict';

  var pluginName = 'radioslider',
      pluginNumber = 0,
      defaults = {
          size:            '', // General slider size
          animation:       true, // Enable fill animation
          isDisabledd:      false, // Make the inputs disabled
          fillOffset:      null, // Offset the fill center
          fillOrigin:      null, // Make the fill bidirectional
          fit:             false, // Fit the edges
          onSelect:        null,
          orientation:     'horizontal',
          sliderClass:     'radioslider',
          itemClass:       'radioslider__item',
          inputClass:      'radioslider__input',
          labelClass:      'radioslider__label',
          dotClass:        'radioslider__dot',
          textClass:       'radioslider__text',
          barClass:        'radioslider__bar',
          fillClass:       'radioslider__fill',
          handleClass:     'radioslider__handle',
          horizontalClass: 'radioslider_horizontal',
          verticalClass:   'radioslider_vertical',
          fitClass:        'radioslider_fit',
          animationClass:  'radioslider_animated',
          dotUnderClass:   'under',
          inverseClass:    'inverse',
          activeClass:     'active',
          focusClass:      'focused',
          disabledClass:   'disabled',
      },
      constants = {
          orientation: {
              horizontal: {
                  dimension: 'width',
                  direction: 'left',
                  directionStyle: 'left',
                  coordinate: 'x'
              },
              vertical: {
                  dimension: 'height',
                  direction: 'top',
                  directionStyle: 'bottom',
                  coordinate: 'y'
              }
          }
      };

  /**
   * Plugin
   * @param {String} element
   * @param {Object} options
   */
  function Plugin(element, options) {
      pluginNumber++;

      this.$window         = $(window);
      this.$document       = $(document);
      this.$bearer         = $(element);
      this.options         = $.extend( {}, defaults, options, this.$bearer.data() );
      this.orientation     = this.options.orientation;
      this.DIMENSION       = constants.orientation[this.orientation].dimension;
      this.DIRECTION       = constants.orientation[this.orientation].direction;
      this.DIRECTION_STYLE = constants.orientation[this.orientation].directionStyle;
      this.COORDINATE      = constants.orientation[this.orientation].coordinate;

      this.number          = pluginNumber;
      this.identifier      = pluginName + '-' + pluginNumber;
      this.level           = 0; // This means no level selected
      this.value           = null;
      this.levelsCount     = this.$bearer.find('input[type=radio]').length;
      // this.$item        = $('<div class="' + this.options.itemClass + '">');
      // this.$dot         = $('<span class="' + this.options.dotClass + '">');
      // this.$text        = $('<span class="' + this.options.textClass + '">');
      this.$bar            = $('<span class="' + this.options.barClass + '">');
      this.$fill           = $('<span class="' + this.options.fillClass + '">');
      this.$handle         = $('<span class="' + this.options.handleClass + '">');
      this.$bar
          .append(this.$fill.css('visibility', 'hidden'))
          .append(this.$handle);

      this.init();
  }

  Plugin.prototype.init = function() {
      this.activate();

      if (this.onInit && typeof this.onInit === 'function') {
          this.onInit();
      }
  };

  Plugin.prototype.activate = function() {
      this.addBase();
      this.setSlider();
      this.addInteraction();
      if (this.options.isDisabledd) {
          this.setDisabled();
      }
  };

  // Add container to DOM, wrap inputs and labels in containers, add bar
  Plugin.prototype.addBase = function() {
      var options = this.options,
          $bearer = this.$bearer,
          $bar    = this.$bar,
          $items,
          $inputs,
          $labels,
          $dots;

      // Container
      $bearer
          .addClass(
              options.sliderClass +
              ' ' + options[this.orientation + 'Class'] +
              ' ' + (options.fit ? options.fitClass : '') +
              ' ' + (options.animation ? options.animationClass : '') +
              ' ' + (options.size ? options.sliderClass + '_' + options.size : '')
          )
          .attr('data-radioslider', this.number);

      // Inputs : add class and level data
      // Store the initial disabled inputs
      $inputs = $bearer
          .find('> input[type=radio]')
          .each(function(i) {
              $(this)
                  .addClass(options.inputClass)
                  .attr('data-level', i+1);
          });
      this.$inputs = $inputs;
      this.$inputsDisabled = this.$bearer.find('> input[type=radio][disabled]');

      // Labels : add class and level data, insert dots, wrap text
      $labels = $bearer
          .find('> label')
          .each(function(i) {
              var level,
                  value,
                  text,
                  $text,
                  $dot;

              text  = $(this).html();
              $text = $('<span class="' + options.textClass + '">').html(text);
              level = i+1;
              value = $inputs.filter('[data-level=' + level + ']').attr('value');
              $dot  = $('<span class="' + options.dotClass + '">')
                  .attr('data-level', level)
                  .attr('data-value', value);

              $(this)
                  .addClass(options.labelClass)
                  .html('')
                  .append($dot)
                  .append($text);
          });
      $dots = $bearer.find('.' + options.dotClass);
      this.$dots = $dots;
      this.$labels = $labels;

      // Items : wrap inputs and labels together
      $inputs.each(function() {
          var $item = $('<div class="' + options.itemClass + '">');
          $(this)
              .nextUntil('input')
              .addBack()
              .wrapAll($item);
          // Add disabled class
          if ($(this).attr('disabled') === 'disabled') {
              $(this).parent().addClass(options.disabledClass);
          }
      });
      $items = $bearer.find('.' + options.itemClass);
      this.$items = $items;
      // If vertical, inverse order
      if (this.orientation === 'vertical') {
          $items.each(function(i, el){
              $bearer.prepend(el);
          });
      }

      // Bar
      $bearer.append($bar);
  };

  // Update the fill bar and current level based on checked radio
  Plugin.prototype.setSlider = function() {
      var $inputChecked = this.$inputs.filter(':checked');

      if ($inputChecked.length > 0) {
          var options    = this.options,
              $inputs    = this.$inputs,
              $bar       = this.$bar,
              $fill      = this.$fill,
              $handle    = this.$handle,
              fillOrigin = options.fillOrigin,
              fillOffset = options.fillOffset,
              $handleOrigin,
              currentValue,
              currentLevel,
              originLevel,
              lowLevel,
              highLevel,
              dotPos,
              originPos,
              // handleOffset,
              barOffset,
              fillDimension,
              fillDirection,
              input;

          // Put active class
          $inputChecked.next('.'+options.labelClass).addClass(options.activeClass).parents('.'+options.itemClass).addClass(options.activeClass);
          $inputs.not($inputChecked).next('.'+options.labelClass).removeClass(options.activeClass).parents('.'+options.itemClass).removeClass(options.activeClass);

          // Get elements dimensions
          currentLevel     = Number($inputChecked.attr('data-level'));
          currentValue     = this.getValueFromLevel(currentLevel);
          dotPos           = this.getPositionFromValue(currentValue);
          barOffset        = this.getBarOffset(); // half bar height/width
          // handleOffset     = this.getHandleOffset(); // half handle height/width

          // Set fill dimensions and position
          // If different origin
          if (
              fillOrigin !== null && (originPos = this.getPositionFromValue(fillOrigin)) || fillOffset !== null && (originPos = this.getPositionFromValue(fillOffset))
          ) {
              originLevel = fillOrigin !== null ? this.getLevelFromValue(fillOrigin) : this.getLevelFromValue(fillOffset);
              $fill.css('opacity', '').addClass('offseted');

              // Insert a secondary handle at the offset origin
              if (!this.$handleOrigin) {
                  $handleOrigin = $('<span class="' + this.options.handleClass + ' ' + options.handleClass + '_origin">');
                  this.$handleOrigin = $handleOrigin;
                  $fill.after($handleOrigin);
                  $handleOrigin[0].style[this.DIRECTION_STYLE] = this.dimensionToPercent(originPos/* - handleOffset*/) + '%';
              } else {
                  $handleOrigin = this.$handleOrigin;
              }

              // Positive direction
              if (currentLevel >= originLevel) {
                  $bar.removeClass(options.inverseClass);
                  $handleOrigin.removeClass(options.inverseClass).css('opacity', '');
                  switch (this.orientation) {
                      case 'horizontal':
                          fillDimension = dotPos - originPos/* + (barOffset * 2)*/;
                          fillDirection = originPos/* - barOffset*/;
                          break;
                      case 'vertical':
                          fillDimension = dotPos - originPos;
                          fillDirection = originPos;
                          break;
                  }
              // Inverse with fillorigin
              } else if (fillOrigin !== null) {
                  $bar.addClass(options.inverseClass);
                  $handleOrigin.addClass(options.inverseClass);
                  switch (this.orientation) {
                      case 'horizontal':
                          fillDimension = originPos - dotPos/* + (barOffset * 2)*/;
                          fillDirection = dotPos/* - barOffset*/;
                          break;
                      case 'vertical':
                          fillDimension = originPos + dotPos;
                          fillDirection = dotPos;
                          break;
                  }
              // Inverse with filloffset
              } else {
                  $handleOrigin.css('opacity', 0);
                  $fill.css('opacity', 0);
                  fillDimension = barOffset * 2;
                  fillDirection = dotPos/* - barOffset*/;
              }
          // If normal origin
          } else  {
              fillDimension = dotPos/* + barOffset*/;
              fillDirection = 0;
          }

          // Show the fill bar
          $fill.css('visibility', '');
          $fill[0].style[this.DIRECTION_STYLE] = this.dimensionToPercent(fillDirection) + '%';
          if (this.orientation === 'vertical') {
              $fill[0].style[this.DIMENSION] = 100 - this.dimensionToPercent(fillDimension) + '%';
              $handle[0].style[this.DIRECTION_STYLE] = 100 - this.dimensionToPercent(dotPos/* - handleOffset*/) + '%';
          } else {
              $fill[0].style[this.DIMENSION] = this.dimensionToPercent(fillDimension) + '%';
              $handle[0].style[this.DIRECTION_STYLE] = this.dimensionToPercent(dotPos/* - handleOffset*/) + '%';
          }

          // Update globals
          this.level = currentLevel;
          this.value = currentValue;

          // Set style for lower levels
          input = 0;
          lowLevel = originLevel ? Math.min(originLevel, currentLevel) : 1;
          highLevel = originLevel ? Math.max(originLevel, currentLevel) : currentLevel;
          $inputs.each(function() {
              input++;

              var $this       = $(this),
                  $dot        = $this.next('label').find('.' + options.dotClass),
                  level       = Number($this.attr('data-level')),
                  ignoreUnder = (fillOffset !== null && currentLevel < originLevel);

              // Current level
              if (level === currentLevel) {
                  $dot.css('opacity', '0');
              // Outside the fill
              } else if (level < lowLevel || level > highLevel || ignoreUnder) {
                  $dot
                      .css('opacity', '')
                      .removeClass(options.dotUnderClass);
              // Under the fill
              } else {
                  $dot
                      .css('opacity', '')
                      .addClass(options.dotUnderClass);
              }
          });
      }
  };

  // Interaction
  Plugin.prototype.addInteraction = function() {
      var slider  = this,
          $bearer = this.$bearer,
          $inputs = this.$inputs,
          $handle = this.$handle;

      // Radio input change
      $inputs.on('change.' + slider.identifier, function() {

          $(this).prop('checked', true);

          if (slider.options.onSelect) {
              slider.options.onSelect($(this), [$inputs]);
          }

          slider.setSlider();
          $bearer.trigger('radiochange', { origin: slider.identifier });
      }).on('focusin.' + slider.identifier, function() {
          $handle.addClass(slider.options.focusClass);
      }).on('focusout.' + slider.identifier, function() {
          $handle.removeClass(slider.options.focusClass);
      });

  };

  // Disable the slider
  Plugin.prototype.setDisabled = function(callback) {
      this.options.isDisabled = true;

      var slider        = this,
          $bearer       = slider.$bearer,
          $labels       = slider.$labels,
          $inputs       = slider.$inputs,
          disabledClass = slider.options.disabledClass;

      // Add disabled attribute and cancel click and change events
      $.merge($labels, $inputs).each(function() {
          $(this).off('click change');
      });
      $inputs.each(function() {
          $(this)
              .prop('disabled', true)
              .parent().addClass(disabledClass);
      });

      if (typeof callback === 'function') {
          callback($labels, $inputs);
      }

      $bearer
          .addClass(disabledClass)
          .trigger('radiodisabled', { origin: this.identifier });
  };

  // Enable the slider
  Plugin.prototype.setEnabled = function(callback) {
      this.options.isDisabled = false;

      var slider        = this,
          $bearer       = slider.$bearer,
          $labels       = slider.$labels,
          $inputs       = slider.$inputs,
          disabledClass = slider.options.disabledClass;

      // Remove the disabled attribute except those which were already here on init
      $inputs.not(slider.$inputsDisabled).each(function() {
          $(this)
              .prop('disabled', false)
              .parent().removeClass(disabledClass);
      });

      // Add interaction back
      slider.addInteraction();

      if (typeof callback === 'function') {
          callback($labels, $inputs);
      }

      $bearer
          .trigger('radiodenabled', { origin: this.identifier })
          .removeClass(disabledClass);
  };

  // Get current value
  Plugin.prototype.getValue = function() {
      return this.value;
  };

  // Set the value
  Plugin.prototype.setValue = function(value) {
      if (value !== this.value) {
          this.$inputs
              .filter('[value=' + value + ']')
              .trigger('click', { origin: this.identifier });
      }
  };

  // Get level from value
  Plugin.prototype.getLevelFromValue = function(value) {
      var level;

      level = Number(this.$inputs.filter('[value="' + value + '"]').attr('data-level'));
      level = (!Number.isNaN(level)) ? level : 0;

      return level;
  };

  // Get value from level
  Plugin.prototype.getValueFromLevel = function(level) {
      var value;

      value = this.$inputs.filter('[data-level=' + level + ']').attr('value');

      return value;
  };

  // Get the position of center of the dot corresponding to a value
  Plugin.prototype.getPositionFromValue = function(value) {
      var position, dimensions, dimension, $dot;

      if (($dot = this.$dots.filter('[data-value="' + value + '"]')) && $dot.length > 0) {
          dimensions = {
              width:  $dot.outerWidth(),
              height: $dot.outerHeight(),
          };
          dimension = dimensions[this.DIMENSION];
          position = $dot.position()[this.DIRECTION] + dimension/2;
      }
      position = (!Number.isNaN(position)) ? position : 0;

      return position;
  };

  // Get the position offset of the handle (eg. half its length)
  /*
  Plugin.prototype.getHandleOffset = function() {
      var handleDimensions,
          handleDimension,
          offset;

      handleDimensions = {
          width:  this.$handle.outerWidth(),
          height: this.$handle.outerHeight(),
      };
      handleDimension = handleDimensions[this.DIMENSION];
      offset          = handleDimension / 2;
      offset          = (!Number.isNaN(offset)) ? offset : 0;

      return offset;
  };
  */

  // Get the position offset of the bar (eg. half its length)
  Plugin.prototype.getBarOffset = function() {
      var barDimensions,
          barDimension,
          offset;

      // Yes, dimensions are switched on purpose
      barDimensions = {
          width:  this.$bar.outerHeight(),
          height: this.$bar.outerWidth(),
      };
      barDimension = barDimensions[this.DIMENSION];
      offset       = barDimension / 2;
      offset       = (!Number.isNaN(offset)) ? offset : 0;

      return offset;
  };

  // Convert a dimension to a percentage of the bearer length
  Plugin.prototype.dimensionToPercent = function(dimension) {
      var bearerDimensions,
          bearerDimension,
          percent;

      bearerDimensions = {
          width: this.$bearer.outerWidth(),
          height: this.$bearer.outerHeight(),
      };
      bearerDimension = bearerDimensions[this.DIMENSION];
      percent = dimension * 100 / bearerDimension;

      return percent;
  };

  // Destroy
  Plugin.prototype.destroy = function() {
      var options = this.options;

      // Remove event handlers
      this.$document.off('.' + this.identifier);
      this.$window.off('.' + this.identifier);
      this.$bearer.off('.' + this.identifier).removeData('plugin_' + pluginName);
      this.$inputs.off('.' + this.identifier);

      // Remove the generated markup
      this.$bearer
          .removeAttr('data-radioslider')
          .removeClass(
              options.sliderClass + ' ' +
              options[this.orientation + 'Class'] + ' ' +
              options.fitClass + ' ' +
              options.animationClass + ' ' +
              options.sliderClass + '_' + options.size
          );
      this.$dots.remove();
      this.$bar.remove();
      this.$items.children().unwrap().each(function(){
          var $this = $(this),
              text;
          $this
              .removeAttr('data-level')
              .removeClass(options.inputClass + ' ' + options.labelClass + ' ' + options.textClass);
          if (this.children.length >0 ) {
              text = $this.children().html();
              $this.children().remove();
              $this.html(text);
          }
      });
      this.$bearer.find('[class=""]').removeAttr('class');
      
  };

  // A really lightweight plugin wrapper around the constructor,
  // preventing against multiple instanciations
  $.fn[pluginName] = function(options) {
      var args = Array.prototype.slice.call(arguments, 1);

      return this.each(function() {
          var $this = $(this),
              data  = $this.data('plugin_' + pluginName);

          // Create a new instance.
          if (!data) {
              $this.data('plugin_' + pluginName, (data = new Plugin(this, options)));
          }

          // Make it possible to access methods from public.
          // e.g `$element.radioslider('method');`
          if (typeof options === 'string') {
              data[options].apply(data, args);
          }
      });
  };

})(jQuery);
// Generated by CoffeeScript 1.9.2

/**
@license Sticky-kit v1.1.2 | WTFPL | Leaf Corcoran 2015 | http://leafo.net
 */

(function() {
  var $, win;

  $ = this.jQuery || window.jQuery;

  win = $(window);

  $.fn.stick_in_parent = function(opts) {
    var doc, elm, enable_bottoming, fn, i, inner_scrolling, len, manual_spacer, offset_top, parent_selector, recalc_every, sticky_class;
    if (opts == null) {
      opts = {};
    }
    sticky_class = opts.sticky_class, inner_scrolling = opts.inner_scrolling, recalc_every = opts.recalc_every, parent_selector = opts.parent, offset_top = opts.offset_top, manual_spacer = opts.spacer, enable_bottoming = opts.bottoming;
    if (offset_top == null) {
      offset_top = 0;
    }
    if (parent_selector == null) {
      parent_selector = void 0;
    }
    if (inner_scrolling == null) {
      inner_scrolling = true;
    }
    if (sticky_class == null) {
      sticky_class = "is_stuck";
    }
    doc = $(document);
    if (enable_bottoming == null) {
      enable_bottoming = true;
    }
    fn = function(elm, padding_bottom, parent_top, parent_height, top, height, el_float, detached) {
      var bottomed, detach, fixed, last_pos, last_scroll_height, offset, parent, recalc, recalc_and_tick, recalc_counter, spacer, tick;
      if (elm.data("sticky_kit")) {
        return;
      }
      elm.data("sticky_kit", true);
      last_scroll_height = doc.height();
      parent = elm.parent();
      if (parent_selector != null) {
        parent = parent.closest(parent_selector);
      }
      if (!parent.length) {
        throw "failed to find stick parent";
      }
      fixed = false;
      bottomed = false;
      spacer = manual_spacer != null ? manual_spacer && elm.closest(manual_spacer) : $("<div />");
      if (spacer) {
        spacer.css('position', elm.css('position'));
      }
      recalc = function() {
        var border_top, padding_top, restore;
        if (detached) {
          return;
        }
        last_scroll_height = doc.height();
        border_top = parseInt(parent.css("border-top-width"), 10);
        padding_top = parseInt(parent.css("padding-top"), 10);
        padding_bottom = parseInt(parent.css("padding-bottom"), 10);
        parent_top = parent.offset().top + border_top + padding_top;
        parent_height = parent.height();
        if (fixed) {
          fixed = false;
          bottomed = false;
          if (manual_spacer == null) {
            elm.insertAfter(spacer);
            spacer.detach();
          }
          elm.css({
            position: "",
            top: "",
            width: "",
            bottom: ""
          }).removeClass(sticky_class);
          restore = true;
        }
        top = elm.offset().top - (parseInt(elm.css("margin-top"), 10) || 0) - offset_top;
        height = elm.outerHeight(true);
        el_float = elm.css("float");
        if (spacer) {
          spacer.css({
            width: elm.outerWidth(true),
            height: height,
            display: elm.css("display"),
            "vertical-align": elm.css("vertical-align"),
            "float": el_float
          });
        }
        if (restore) {
          return tick();
        }
      };
      recalc();
      if (height === parent_height) {
        return;
      }
      last_pos = void 0;
      offset = offset_top;
      recalc_counter = recalc_every;
      tick = function() {
        var css, delta, recalced, scroll, will_bottom, win_height;
        if (detached) {
          return;
        }
        recalced = false;
        if (recalc_counter != null) {
          recalc_counter -= 1;
          if (recalc_counter <= 0) {
            recalc_counter = recalc_every;
            recalc();
            recalced = true;
          }
        }
        if (!recalced && doc.height() !== last_scroll_height) {
          recalc();
          recalced = true;
        }
        scroll = win.scrollTop();
        if (last_pos != null) {
          delta = scroll - last_pos;
        }
        last_pos = scroll;
        if (fixed) {
          if (enable_bottoming) {
            will_bottom = scroll + height + offset > parent_height + parent_top;
            if (bottomed && !will_bottom) {
              bottomed = false;
              elm.css({
                position: "fixed",
                bottom: "",
                top: offset
              }).trigger("sticky_kit:unbottom");
            }
          }
          if (scroll < top) {
            fixed = false;
            offset = offset_top;
            if (manual_spacer == null) {
              if (el_float === "left" || el_float === "right") {
                elm.insertAfter(spacer);
              }
              spacer.detach();
            }
            css = {
              position: "",
              width: "",
              top: ""
            };
            elm.css(css).removeClass(sticky_class).trigger("sticky_kit:unstick");
          }
          if (inner_scrolling) {
            win_height = win.height();
            if (height + offset_top > win_height) {
              if (!bottomed) {
                offset -= delta;
                offset = Math.max(win_height - height, offset);
                offset = Math.min(offset_top, offset);
                if (fixed) {
                  elm.css({
                    top: offset + "px"
                  });
                }
              }
            }
          }
        } else {
          if (scroll > top) {
            fixed = true;
            css = {
              position: "fixed",
              top: offset
            };
            css.width = elm.css("box-sizing") === "border-box" ? elm.outerWidth() + "px" : elm.width() + "px";
            elm.css(css).addClass(sticky_class);
            if (manual_spacer == null) {
              elm.after(spacer);
              if (el_float === "left" || el_float === "right") {
                spacer.append(elm);
              }
            }
            elm.trigger("sticky_kit:stick");
          }
        }
        if (fixed && enable_bottoming) {
          if (will_bottom == null) {
            will_bottom = scroll + height + offset > parent_height + parent_top;
          }
          if (!bottomed && will_bottom) {
            bottomed = true;
            if (parent.css("position") === "static") {
              parent.css({
                position: "relative"
              });
            }
            return elm.css({
              position: "absolute",
              bottom: padding_bottom,
              top: "auto"
            }).trigger("sticky_kit:bottom");
          }
        }
      };
      recalc_and_tick = function() {
        recalc();
        return tick();
      };
      detach = function() {
        detached = true;
        win.off("touchmove", tick);
        win.off("scroll", tick);
        win.off("resize", recalc_and_tick);
        $(document.body).off("sticky_kit:recalc", recalc_and_tick);
        elm.off("sticky_kit:detach", detach);
        elm.removeData("sticky_kit");
        elm.css({
          position: "",
          bottom: "",
          top: "",
          width: ""
        });
        parent.position("position", "");
        if (fixed) {
          if (manual_spacer == null) {
            if (el_float === "left" || el_float === "right") {
              elm.insertAfter(spacer);
            }
            spacer.remove();
          }
          return elm.removeClass(sticky_class);
        }
      };
      win.on("touchmove", tick);
      win.on("scroll", tick);
      win.on("resize", recalc_and_tick);
      $(document.body).on("sticky_kit:recalc", recalc_and_tick);
      elm.on("sticky_kit:detach", detach);
      return setTimeout(tick, 0);
    };
    for (i = 0, len = this.length; i < len; i++) {
      elm = this[i];
      fn($(elm));
    }
    return this;
  };

}).call(this);
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.ThreeSixty=t():e.ThreeSixty=t()}(self,(()=>(()=>{"use strict";var e={d:(t,i)=>{for(var n in i)e.o(i,n)&&!e.o(t,n)&&Object.defineProperty(t,n,{enumerable:!0,get:i[n]})}};e.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),e.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t);var t={};function i(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function n(e,t,i){!function(e,t){if(t.has(e))throw new TypeError("Cannot initialize the same private elements twice on an object")}(e,t),t.set(e,i)}function o(e,t){return function(e,t){return t.get?t.get.call(e):t.value}(e,r(e,t,"get"))}function s(e,t,i){return function(e,t,i){if(t.set)t.set.call(e,i);else{if(!t.writable)throw new TypeError("attempted to set read only private field");t.value=i}}(e,r(e,t,"set"),i),i}function r(e,t,i){if(!t.has(e))throw new TypeError("attempted to "+i+" private field on non-instance");return t.get(e)}e.d(t,{default:()=>x});var a=new WeakMap,h=new WeakMap,u=new WeakMap,c=function(){function e(t,i){var r=this;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),n(this,a,{writable:!0,value:null}),n(this,h,{writable:!0,value:null}),n(this,u,{writable:!0,value:null}),s(this,h,i),s(this,u,{container:{mousedown:function(e){return s(r,a,e.pageX)},touchstart:function(e){return s(r,a,e.touches[0].clientX)},touchend:function(){return s(r,a,null)}},prev:{mousedown:function(e){e.preventDefault(),t.play(!0)},mouseup:function(e){e.preventDefault(),t.stop()},touchstart:function(e){e.preventDefault(),t.prev()}},next:{mousedown:function(e){e.preventDefault(),t.play()},mouseup:function(e){e.preventDefault(),t.stop()},touchstart:function(e){e.preventDefault(),t.next()}},global:{mouseup:function(){return s(r,a,null)},mousemove:function(e){o(r,a)&&Math.abs(o(r,a)-e.pageX)>o(r,h).dragTolerance&&(t.stop(),o(r,a)>e.pageX?t.prev():t.next(),s(r,a,e.pageX))},touchmove:function(e){o(r,a)&&Math.abs(o(r,a)-e.touches[0].clientX)>o(r,h).swipeTolerance&&(t.stop(),o(r,a)>e.touches[0].clientX?t.prev():t.next(),s(r,a,e.touches[0].clientX))},keydown:function(e){[37,39].includes(e.keyCode)&&t.play(37===e.keyCode)},keyup:function(e){[37,39].includes(e.keyCode)&&t.stop()}}}),this._initEvents()}var t,r;return t=e,(r=[{key:"destroy",value:function(){o(this,h).swipeTarget.removeEventListener("mousedown",o(this,u).container.mousedown),o(this,h).swipeTarget.removeEventListener("touchstart",o(this,u).container.touchstart),o(this,h).swipeTarget.removeEventListener("touchend",o(this,u).container.touchend),window.removeEventListener("mouseup",o(this,u).global.mouseup),window.removeEventListener("mousemove",o(this,u).global.mousemove),window.removeEventListener("touchmove",o(this,u).global.touchmove),window.removeEventListener("keydown",o(this,u).global.keydown),window.removeEventListener("keyup",o(this,u).global.keyup),o(this,h).prev&&(o(this,h).prev.removeEventListener("mousedown",o(this,u).prev.mousedown),o(this,h).prev.removeEventListener("mouseup",o(this,u).prev.mouseup),o(this,h).prev.removeEventListener("touchstart",o(this,u).prev.touchstart)),o(this,h).next&&(o(this,h).next.removeEventListener("mousedown",o(this,u).next.mousedown),o(this,h).next.removeEventListener("mouseup",o(this,u).next.mouseup),o(this,h).next.removeEventListener("touchstart",o(this,u).next.touchstart))}},{key:"_initEvents",value:function(){o(this,h).draggable&&(o(this,h).swipeTarget.addEventListener("mousedown",o(this,u).container.mousedown),window.addEventListener("mouseup",o(this,u).global.mouseup),window.addEventListener("mousemove",o(this,u).global.mousemove)),o(this,h).swipeable&&(o(this,h).swipeTarget.addEventListener("touchstart",o(this,u).container.touchstart),o(this,h).swipeTarget.addEventListener("touchend",o(this,u).container.touchend),window.addEventListener("touchmove",o(this,u).global.touchmove)),o(this,h).keys&&(window.addEventListener("keydown",o(this,u).global.keydown),window.addEventListener("keyup",o(this,u).global.keyup)),o(this,h).prev&&(o(this,h).prev.addEventListener("mousedown",o(this,u).prev.mousedown),o(this,h).prev.addEventListener("mouseup",o(this,u).prev.mouseup),o(this,h).prev.addEventListener("touchstart",o(this,u).prev.touchstart)),o(this,h).next&&(o(this,h).next.addEventListener("mousedown",o(this,u).next.mousedown),o(this,h).next.addEventListener("mouseup",o(this,u).next.mouseup),o(this,h).next.addEventListener("touchstart",o(this,u).next.touchstart))}}])&&i(t.prototype,r),Object.defineProperty(t,"prototype",{writable:!1}),e}();const l=c;function p(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function v(e,t,i){!function(e,t){if(t.has(e))throw new TypeError("Cannot initialize the same private elements twice on an object")}(e,t),t.set(e,i)}function d(e,t){return function(e,t){return t.get?t.get.call(e):t.value}(e,f(e,t,"get"))}function w(e,t,i){return function(e,t,i){if(t.set)t.set.call(e,i);else{if(!t.writable)throw new TypeError("attempted to set read only private field");t.value=i}}(e,f(e,t,"set"),i),i}function f(e,t,i){if(!t.has(e))throw new TypeError("attempted to "+i+" private field on non-instance");return t.get(e)}var y=new WeakMap,g=new WeakMap,m=new WeakMap,b=new WeakMap,k=new WeakMap,E=new WeakMap,L=new WeakMap;const x=function(){function t(e,i){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),v(this,y,{writable:!0,value:null}),v(this,g,{writable:!0,value:0}),v(this,m,{writable:!0,value:null}),v(this,b,{writable:!0,value:!1}),v(this,k,{writable:!0,value:null}),v(this,E,{writable:!0,value:null}),v(this,L,{writable:!0,value:!1}),this.container=e,w(this,y,Object.assign({width:300,height:300,aspectRatio:0,count:0,perRow:0,speed:100,dragTolerance:10,swipeTolerance:10,draggable:!0,swipeable:!0,keys:!0,inverted:!1},i)),d(this,y).swipeTarget=d(this,y).swipeTarget||this.container,w(this,L,!Array.isArray(d(this,y).image)),this.sprite||(d(this,y).count=d(this,y).image.length),Object.freeze(d(this,y)),w(this,E,new l(this,d(this,y))),this._windowResizeListener=this._windowResizeListener.bind(this),this._initContainer(),this.nloops=0}var i,n;return i=t,(n=[{key:"isResponsive",get:function(){return d(this,y).aspectRatio>0}},{key:"containerWidth",get:function(){return this.isResponsive?this.container.clientWidth:d(this,y).width}},{key:"containerHeight",get:function(){return this.isResponsive?this.container.clientWidth*d(this,y).aspectRatio:d(this,y).height}},{key:"index",get:function(){return d(this,g)}},{key:"looping",get:function(){return d(this,b)}},{key:"sprite",get:function(){return d(this,L)}},{key:"next",value:function(){this.goto(d(this,y).inverted?d(this,g)-1:d(this,g)+1)}},{key:"prev",value:function(){this.goto(d(this,y).inverted?d(this,g)+1:d(this,g)-1)}},{key:"goto",value:function(e){w(this,g,(d(this,y).count+e)%d(this,y).count),this._update()}},{key:"play",value:function(e,t){this.looping||(this._loop(e),w(this,b,!0),w(this,k,t),this.nloops=0)}},{key:"stop",value:function(){this.looping&&(e.g.clearTimeout(d(this,m)),w(this,b,!1),w(this,k,null),this.nloops=0)}},{key:"toggle",value:function(e){this.looping?this.stop():this.play(e)}},{key:"destroy",value:function(){this.stop(),d(this,E).destroy(),this.container.style.width="",this.container.style.height="",this.container.style.backgroundImage="",this.container.style.backgroundPositionX="",this.container.style.backgroundPositionY="",this.container.style.backgroundSize="",this.isResponsive&&window.removeEventListener("resize",this._windowResizeListener)}},{key:"_loop",value:function(t){var i=this;t?this.prev():this.next(),0===d(this,g)&&(this.nloops+=1,d(this,k)&&this.nloops>=d(this,k))?this.stop():w(this,m,e.g.setTimeout((function(){i._loop(t)}),d(this,y).speed))}},{key:"_update",value:function(){this.sprite?(this.container.style.backgroundPositionX=-d(this,g)%d(this,y).perRow*this.containerWidth+"px",this.container.style.backgroundPositionY=-Math.floor(d(this,g)/d(this,y).perRow)*this.containerHeight+"px"):this.container.style.backgroundImage='url("'.concat(d(this,y).image[d(this,g)],'")')}},{key:"_windowResizeListener",value:function(){this.container.style.height=this.containerHeight+"px",this._update()}},{key:"_initContainer",value:function(){if(this.isResponsive||(this.container.style.width=this.containerWidth+"px"),this.container.style.height=this.containerHeight+"px",this.sprite){this.container.style.backgroundImage='url("'.concat(d(this,y).image,'")');var e=d(this,y).perRow,t=Math.ceil(d(this,y).count/d(this,y).perRow);this.container.style.backgroundSize=100*e+"% "+100*t+"%"}this.isResponsive&&window.addEventListener("resize",this._windowResizeListener),this._update()}}])&&p(i.prototype,n),Object.defineProperty(i,"prototype",{writable:!1}),t}();return t.default})()));
(function ($, Drupal, drupalSettings) {
  "use strict";

  /* 
  | ----------------------------
  | Checkout pop up Terms  
  | ----------------------------
  */
  $('.form-item-custom-pane-message-terms label').on('click', function(e){
    e.preventDefault();
    var dataClick = "data-click"; 
    var dataShow = "data-show";

    var data = $(this).children().attr(dataClick);
    $('body').find('[data-show=' + data + ']').addClass('active');
  });
  
  $('.accept').on('click', function(){
    var data = $(this).attr('data-check');
    var parent = $('body').find('[data-click=' + data + ']').parent().siblings().prop("checked", true);;
    $('.node-page-checkout').removeClass('active');
  })
  $('.decline').on('click', function(){
    var data = $(this).attr('data-uncheck');
    var parent = $('body').find('[data-click=' + data + ']').parent().siblings().prop("checked", false);;

    $('.node-page-checkout').removeClass('active');
  })
  /* 
  | ----------------------------
  | Checkout sidebar mobile  
  | ----------------------------
  */
  if ($(".checkout-sidebar").length > 0) {
    $(document).on('click', '.js-summary-open', function (e) {
    // $("").on('click',function () {
      $(this).toggleClass("active");
      $(this).siblings().stop().slideToggle();
    });

    $(window).resize(function () {
      $(".container-wrapper").removeAttr("style");
    });
  }

  /* 
  | ----------------------------
  | Car Equipment  
  | ----------------------------
  */
  if ($('.field_car_equipment-show-more').length) {
    $('.field_car_equipment-show-more').on('click', function () {
      $(this).toggleClass('active');
      $(this).siblings('.field__items.hide').toggleClass('active');
    })
  }

  /* 
  | ----------------------------
  | Color slider  
  | ----------------------------
  */
  // if ($(".swiper-colors").length) {
  //   var swiper = new Swiper(".swiper-colors", {
  //     slidesPerView: 1,
  //     spaceBetween: 10,
  //     centeredSlides: true,
  //     navigation: {
  //       nextEl: ".swiper-button-next",
  //       prevEl: ".swiper-button-prev",
  //     },
  //     breakpoints: {
  //       768: {
  //         slidesPerView: "auto",
  //         centeredSlides: false,
  //       },
  //     },
  //   });
  // }

  /* 
  | ----------------------------
  | Image slider  
  | ----------------------------
  */
  if ($(".swiper-color-image").length) {
    colorImageSwiper();
  }

  /* 
  | ----------------------------
  | Color tab Ajax change Image Gallery 
  | ----------------------------
  */
  if ($(".paragraph-car-color").length) {
    $(".paragraph-car-color").each(function () {
      $(this).on("click", function () {
        $(this).addClass('paragraph-active-color');
        var paragraph_id = $(this).attr("data-color");

        $.ajax({
          type: "POST",
          url: "/api/paragraph-color",
          data: JSON.stringify(paragraph_id),
          contentType: "application/json",
          dataType: "json",
        }).done(function (response) {
          // console.log(response);
          $(".product-image .swiper-wrapper").html(response);
          colorImageSwiper();
        });
      });
    });
  }

  /* 
  | ----------------------------
  | Commerce Add to cart  
  | ----------------------------
  */
  $(document).on("click", "#custom-add-to-cart-button", function () {
    commerce_api();
  });

  /* 
  | ----------------------------
  | Commerce Attributes & add to cart 
  | ----------------------------
  */
  setTimeout(function(){
    // onload functions here
    radios_to_slider();
    attribute_lease_title();
    attribute_miles_title();
    checkbox_deposit_product_full();
    checkbox_deposit_product_teaser();
  },1000)
  // ajax
  var attributes = [
    "purchased_entity[0][attributes][attribute_lease]",
    "purchased_entity[0][attributes][attribute_miles]",
    "purchased_entity[0][attributes][attribute_deposit]",
  ];

  if(drupalSettings.route != 'commerce_checkout.form'){
    $(document).ajaxComplete(function (event, xhr, settings) {
      
      if ($.inArray(settings.extraData._triggering_element_name, attributes) !== -1) {
        radios_to_slider();
        attribute_lease_title();
        attribute_miles_title();
        checkbox_deposit_product_full();
      }
    });
    
  }

  /* 
  | ----------------------------
  | Helper Functions 
  | ----------------------------
  */
  function colorImageSwiper() {
    var swiper_color_image = new Swiper(".swiper-color-image", {
      slidesPerView: 1,
      effect: "fade",
      speed: 0,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next-color-image",
        prevEl: ".swiper-button-prev-color-image",
      },
    });
  }

  function commerce_api() {
    // var variation = new URLSearchParams(window.location.search).get('v');
    var variation = $("#custom-add-to-cart-button").attr("data-variation-id");
    var paragraph_id = $(document).find(".paragraph-active-color").attr("data-color");

    var vat = false;
    if ($(".tax-checkbox").is(":checked")) {
      vat = true;
    }

    var deposit = false;
    var product_type = drupalSettings.product_type;
    deposit = true;
    // if ($(".check-deposit").is(":checked") || product_type == 1) {
    //   deposit = true;
    // }
    // console.log(deposit);
    // debugger;
    $.ajax({
      type: "POST",
      url: "/"+drupalSettings.path.currentLanguage+"/api/cart",
      data: JSON.stringify({
        variation: variation,
        paragraph_id: paragraph_id,
        deposit: deposit,
        vat: vat,
      }),
      contentType: "application/json",
      dataType: "json",
    }).done(function (response) {
      location.replace(response);
    });
  }

  function checkbox_deposit_product_full() {
    if ($(".product-full .tax-checkbox").length) {
      $(".tax-checkbox").on('click',function () {
        $(".price").toggle();
        $(".list-price").toggle();
        $(".field-deposit").toggleClass('active');
        $('.field-deposit-without-vat').toggleClass('in-active');
      });
    }
  }

  function checkbox_deposit_product_teaser() {
    if ($(".product-teaser .pricing-list").length) {
      $(".pricing-list span").on('click',function () {
        $(this).removeClass('active').addClass('disable');
        $(this).siblings().removeClass('disable').addClass('active');
      });
    }
  }

  function radios_to_slider() {
    $(".car-radios-attibutes").radioslider();
  }

  function attribute_miles_title() {
    $(".attribute-miles .radioslider__item").each(function () {
      if ($(this).hasClass("active")) {
        var text = $(this).find(".radioslider__text").html();
        $(".attribute_miles_title span").html(text);
      }
    });
  }

  function attribute_lease_title() {
    $(".attribute-lease .radioslider__item").each(function () {
      if ($(this).hasClass("active")) {
        var text = $(this).find(".radioslider__text").html();
        $(".attribute_lease_title span").html(text);
      }
    });
  }
})(jQuery, Drupal, drupalSettings);

(function ($, Drupal, drupalSettings) {
  "use strict";

  /* 
  | ----------------------------
  | Accordion (faq)  
  | ----------------------------
  */
  $(document).on("click", ".paragraph-accordion-item", function (e) {
    // $("").click(function () {
    var other = $(".paragraph-accordion-item").not($(this));

    other.removeClass("active");
    other.children(".field-label").removeClass("active");
    other.children(".field-body").stop().slideUp();

    $(this).toggleClass("active");
    $(this).children(".field-label").toggleClass("active");
    $(this).children(".field-body").stop().slideToggle();
  });

  /* 
  | ----------------------------
  | Language  
  | ----------------------------
  */
  $(".language-switcher-language-url .is-active").on("click", function (e) {
    $(this).siblings().toggleClass("open");
    e.preventDefault();
  });

  /* 
  | ----------------------------
  | Mobile burger  
  | ----------------------------
  */
  $(".mobile-burger").on("click", function () {
    $(this).siblings(".menu").toggleClass("open");
  });

  /* 
  | ----------------------------
  | Sidebar sticky  
  | ----------------------------
  */
  $(window).on("load resize", function () {
    if ($(window).width() >= 960) {
      $(
        ".sidebar-container, .region-sidebar-container, .checkout-pane-custom-pane-sidebar"
      ).stick_in_parent({
        offset_top: 110,
        recalc_every: 1,
      });
      $(".region-sidebar-container").trigger("sticky_kit:recalc");
    } else {
      $(
        ".sidebar-container, .region-sidebar-container, .checkout-pane-custom-pane-sidebar"
      ).trigger("sticky_kit:detach");
    }
  });

  $(document).ready(function () {
    if ($(window).width() > 960) {
      var headerHeight = $(
        ".path-taxonomy .taxonomy-content .view-header"
      ).outerHeight();

      var newMarginTop = headerHeight + 30;

      $(".path-taxonomy .region-sidebar-left").css(
        "margin-top",
        newMarginTop + "px"
      );
    }
  });

  /* 
  | ----------------------------
  | Facets && Facets as Tags  
  | ----------------------------
  */
  $(document).on("click", ".block-facets h3", function (e) {
    $(this).toggleClass("active");
    $(this).siblings().stop().slideToggle();
  });

  var facet_tags = new Array();
  setTimeout(function () {
    var facet_tags_children = $(document)
      .find("ul.facet-active a.is-active")
      .clone();
    if (facet_tags_children.length >= 1) {
      facet_tags.push(facet_tags_children);
      $(".facets-tags").append(facet_tags);
      $(".facets-reset")
        .addClass("active")
        .attr("href", window.location.pathname);
    }
  }, 1000);

  $(document).on("click", ".mobile-facet", function (e) {
    // $(".mobile-facet").on("click", function () {
    $(".region-sidebar-left").addClass("active");
  });
  $(document).on("click", ".mobile-facet-close", function (e) {
    // $(".mobile-facet-close").on("click", function () {
    $(".region-sidebar-left").removeClass("active");
  });

  /* 
  | ----------------------------
  | Swiper content article block
  | ----------------------------
  */
  if ($(".swiper-block-article").length) {
    var swiper = new Swiper(".swiper-block-article", {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: true,
      navigation: {
        nextEl: ".swiper-button-next-article",
        prevEl: ".swiper-button-prev-article",
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          centeredSlides: false,
        },
      },
    });
  }

  var swiper = new Swiper(".swiper-text-slider", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 2200,
      disableOnInteraction: false,
    },
  });

  if ($(".swiper-block-article-media .swiper-block-article").length) {
    var swiper = new Swiper(
      ".swiper-block-article-media .swiper-block-article",
      {
        slidesPerView: 1.5,
        spaceBetween: 8,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-button-next-article",
          prevEl: ".swiper-button-prev-article",
        },
        breakpoints: {
          650: {
            slidesPerView: 2.5,
            centeredSlides: false,
          },
          1025: {
            slidesPerView: 3.5,
            centeredSlides: false,
          },
          1300: {
            slidesPerView: 4,
            centeredSlides: false,
          },
        },
      }
    );
  }

  /* 
  | ----------------------------
  | Swiper setup
  | ----------------------------
  */

  function setupSwiper(width, element, options) {
    // breakpoint where swiper will be destroyed
    var breakpoint = window.matchMedia("(min-width:" + width + ")");

    // keep track of swiper instances to destroy later
    var mySwiper;

    var breakpointChecker = function () {
      // if larger viewport and multi-row layout needed
      if (breakpoint.matches === true) {
        // clean up old instances and inline styles when available
        if (mySwiper !== undefined) {
          mySwiper.destroy(true, true);
          // or/and do nothing
          return;
        }

        // else if a small viewport and double column layout needed
      } else {
        // fire small viewport version of swiper
        return enableSwiper();
      }
    };

    var enableSwiper = function () {
      mySwiper = new Swiper(element, options);
    };

    // keep an eye on viewport size changes
    breakpoint.addEventListener("change", () => {
      breakpointChecker();
    });
    // breakpoint.addListener(breakpointChecker);

    // kickstart
    breakpointChecker();
  }

  // //Hero banner icons
  if (
    $(".swiper-icons").length > 0 &&
    $(".swiper-icons .swiper-wrapper").children().length > 1
  ) {
    setupSwiper("1024", ".swiper-icons .swiper-slider", {
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }

  // Common swiper for Hot Offers, Porsche & NIO (+Firefly) view blocks
  $('.hot-offer-swiper, .porsche-swiper, .nio-firefly-swiper').each(function () {
    var $slider = $(this);

    new Swiper($slider[0], {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      centeredSlides: true,
      pagination: {
        el: $slider.find('.swiper-pagination')[0],
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 0,
        },
      },
    });
  });
  /* 
| ----------------------------
| Article animation
| ----------------------------
*/

  showAnimation($(".page-node-type-article .content"));

  function showAnimation(element) {
    $(window).on("scroll", function () {
      if (element.length) {
        var scroll = $(window).scrollTop();
        element.each(function () {
          // console.log($(this));
          // console.log($(this).offset().top);
          // console.log("window:" + $(window).height());
          if (
            $(this).offset().top <
            $(window).scrollTop() + $(window).scrollTop()
          ) {
            $(this).addClass("show");
          }
        });
      }
    });
  }
})(jQuery, Drupal, drupalSettings);
